import React, { useEffect, useRef, useState } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useFormContext } from "react-hook-form";
import { CircularProgress } from "@mui/material";

function LogoPreferences(props) {
  const {
    nextStep,
    prevStep,
    handleSubmit,
    isSubmitting,
    submitted,
    errorMessage,
  } = props;

  const {
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
    getValues,
  } = useFormContext();

  return (
    <>
      <div className="w-full space-y-5">
        <div className="space-y-5">
          <div className="space-y-8 mt-4">
            <div>
              <div className="text-lg text-gray-500">Logo Preferences: </div>
              <div className="space-y-4 mt-2">
                <div className="space-y-2">
                  <div className="text-base text-gray-500">
                    Are there any specific colors you prefer or dislike? *{" "}
                  </div>
                  <div>
                    <textarea
                      name="specific_color"
                      placeholder="e.g. Prefer blue and green; avoid red or neon colors"
                      rows={4}
                      {...register("specific_color", {
                        required:
                          "Please tell us any colors you prefer or dislike.",
                        validate: (v) =>
                          v.trim() !== "" ||
                          "Please tell us any colors you prefer or dislike.",
                      })}
                      className="outline-none border-gray-200 outline-gray-300 w-full rounded-sm  text-gray-500"
                    ></textarea>
                    {errors.specific_color && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.specific_color.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className="space-y-2">
                  <div className="text-base text-gray-500">
                    Do you have a specific style or theme in mind for your logo?
                    *{" "}
                  </div>
                  <div>
                    <textarea
                    placeholder="e.g. Minimal, modern, vintage, playful, luxury, or tech-focused"
                      name="specific_theme"
                      rows={4}
                      {...register("specific_theme", {
                        required:
                          "Please describe the style or theme you have in mind for your logo.",
                        validate: (v) =>
                          v.trim() !== "" ||
                          "Please describe the style or theme you have in mind for your logo.",
                      })}
                      className="outline-none border-gray-200 outline-gray-300 w-full rounded-sm  text-gray-500"
                    ></textarea>
                    {errors.specific_theme && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.specific_theme.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className="space-y-2">
                  <div className="text-base text-gray-500">
                    Do you have any specific symbols or icons you'd like to
                    incorporate?{" "}
                  </div>
                  <textarea
                  placeholder="e.g. Leaf, lightning bolt, initials, abstract mark, or mascot"
                    name="specific_symbols"
                    rows={4}
                    {...register("specific_symbols")}
                    className="outline-none border-gray-200 outline-gray-300 w-full rounded-sm  text-gray-500"
                  ></textarea>
                </div>
                <div className="space-y-2">
                  <div className="text-base text-gray-500">
                    Do you have any specific fonts you like or dislike?{" "}
                  </div>
                  <textarea
                    placeholder="e.g. Like clean sans-serif fonts; dislike script or handwritten styles"
                    name="specific_fonts"
                    rows={4}
                    {...register("specific_fonts")}
                    className="outline-none border-gray-200 outline-gray-300 w-full rounded-sm  text-gray-500"
                  ></textarea>
                </div>
                <div className="space-y-2">
                  <div className="text-base text-gray-500">
                    Do you have a tagline or slogan you'd like to include in the
                    logo?{" "}
                  </div>
                  <textarea
                    placeholder="e.g. Empowering your digital future (or leave blank if none)"
                    name="tagline"
                    rows={4}
                    {...register("tagline")}
                    className="outline-none border-gray-200 outline-gray-300 w-full rounded-sm  text-gray-500"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        {errorMessage && (
          <div className="text-sm text-red-600 ">
            <p>Failed to submit the form. Please try again.</p>
          </div>
        )}

        <div className="flex justify-between items-center">
          <button
            className="p-0 text-gray-500"
            onClick={() => {
              prevStep();
              if (typeof window !== "undefined") {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }
            }}
            disabled={isSubmitting || submitted}
          >
            <FaArrowLeftLong />
          </button>
          <button
            className=" bg-[#FFC067] text-dark font-bold  rounded px-6 py-3 text-base md:text-lg hover:bg-[#DF73FF]  transition ease-in duration-300 cursor-pointer "
            onClick={async () => {
              const isValid = await trigger([
                "brand_voice_and_tone",
                "business_description",
              ]);
              if (isValid) {
                handleSubmit;
              }
            }}
            type="submit"
            disabled={isSubmitting || submitted}
          >
            {submitted ? (
              "Submittted"
            ) : isSubmitting ? (
              <div className="flex space-x-1">
                {" "}
                <CircularProgress
                  color="dark"
                  size="20px"
                  className="mt-1"
                />{" "}
                <p>Submitting...</p>{" "}
              </div>
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </div>
    </>
  );
}

export default LogoPreferences;
